import { render, staticRenderFns } from "./BrowserSupportDialog.vue?vue&type=template&id=4659f383&"
import script from "./BrowserSupportDialog.vue?vue&type=script&lang=ts&"
export * from "./BrowserSupportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports